/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { A as ActionGroup, d as defineCustomElement$1 } from './action-group.js';

const CalciteActionGroup = ActionGroup;
const defineCustomElement = defineCustomElement$1;

export { CalciteActionGroup, defineCustomElement };
